export const enum SCREEN_SIZES {
  mobile = '450px',
  tablet = '900px',
  desktop = '1300px',
}
